// extracted by mini-css-extract-plugin
module.exports = {"marginLeftAuto":"FaveFeedToggleFilter_marginLeftAuto__iCAJ0","filterPane":"FaveFeedToggleFilter_filterPane__14Z8c"};